<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-09-18 14:03:53
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2024-05-08 17:19:25
 * @FilePath: \partner.chaoyongtuan.com\src\views\secondColonelManage\rulesSetting\viewRules\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="view-rules">
		<platformTab type="card" :exclude="excludePlat" @change="handleClick" :showAll="false" :platformId="platformId" />
		<div v-show="showPlatformContent && $isPlatOr(['Dy', 'Ks'])">
			<ruleItem @toggleSwitch="toggleSwitch" :showSwitch="true" :openFlag="delayOpenFlag" v-if="$isDy(platformId)">
				<div slot="title" class="flex-row-align-center">
					<i class="i-blue-shop"></i>
					<span class="font-h4-medium ml-6 mr-4">商品自动延长推广</span>
				</div>
				<div class="ruleList_item_content">
					<el-select @change="handleDelayDaysChange" v-model="delayDays" slot="prepend" placeholder="请选择自动延长时间">
						<el-option :label="item.label" :value="item.value" v-for="item in goodsDelayTimeOptList" :key="item.value"></el-option>
					</el-select>
				</div>
				<div slot="ruleText">
					<p>1、开启后，系统将在“团长活动商品”到期前3天，自动发起延长申请(每日2:00执行)；</p>
					<p>2、开启后关闭，则立即生效，系统不再自动执行；</p>
				</div>
			</ruleItem>
			<ruleItem @toggleSwitch="clashSwitch" :showSwitch="true" :openFlag="clashOpenFlag">
				<div slot="title" class="flex-row-align-center">
					<img class="clash-icon" src="@/assets/public/clash-icon.png" alt="" />
					<span class="font-h4-medium ml-6 mr-4">招商撞单审核设置</span>
				</div>
				<div class="yx-color-text-secondary fz-14 mt-24 mb-16">是否允许审核其他招商正在跟进店铺下的所有商品</div>
				<div class="ruleList_item_content">
					<el-radio :disabled="!clashOpenFlag" :value="clashRadio" :label="0" @change="onRadio(0)">可以审核所有商品</el-radio>
					<el-radio :disabled="!clashOpenFlag" :value="clashRadio" :label="1" @change="onRadio(1)">
						不可以审核其他招商正在推广商品的店铺内所有商品
					</el-radio>
				</div>
				<div slot="ruleText">
					<p>开启撞单审核后：以下规则（二选一）：</p>
					<p>1、可以审核所有商品，即招商可以随意审核商品，不做限制；</p>
					<p>2、不可审核其他招商正在推广商品的店铺内所有商品</p>
					<p>例：商品x属于店铺A，商品x已报名了招商66的活动，即招商66负责店铺A内所有商品</p>
					<p>其他招商将不能审核店铺A内的所有商品</p>
					<p>注意：</p>
					<p>1、开启不可审核，系统预计30分钟完成对现有商品的撞单判断及处理（针对已有多招商跟进情</p>
					<p>况，系统将按“最早认领时间”锁定招商与店铺关系，即作为店铺对接人，并将店铺内已有招商跟进</p>
					<p>的“推广中”商品移交给店铺对接人，历史业绩不受影响）；</p>
					<p>商品流转记录可从[团长商品-商品流转记录]中查看；</p>
					<p>2、招商与店铺绑定关系维护，可从[合作店铺]中直接设置；</p>
					<p>修改店铺对接人后，仅对增量商品有效，历史商品的跟进招商不进行变更；</p>
				</div>
			</ruleItem>
		</div>
		<ruleItem :showExplain="false">
			<div slot="title" class="flex-row-align-center">
				<i class="i-blue-shop"></i>
				<span class="font-h4-medium ml-6 mr-4">商品审核设置</span>
			</div>
			<div class="flex-row flex-align-center pos-rela">
				<i class="line"></i>
				<span class="mr-8 yx-color-text-primary font-h4-regular">审核自动认领</span>
				<el-switch :value="productAuditClaim" inactive-color="#E2E3E8" :active-value="1" :inactive-value="0" @change="productAuditChange"></el-switch>
			</div>
			<div class="mt-8 fz-12" style="color: #86909c">招商审核通过商品后，自动认领商品</div>
		</ruleItem>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import ruleItem from '@/components/business/ruleItem';
import { platformMixin } from '@rd/rd-ui';
import {
	getProductPromotion,
	setProductPromotion,
	getProductConfig,
	setProductDuplicateAlone,
	setProductDuplicate,
	setAuditConfig,
	getAuditConfig,
} from '@/api/settings.js';
import { goodsDelayTimeOptList } from '@/utils/newDataMap/settings.js';

export default {
	components: {
		ruleItem,
	},
	computed: {
		...mapGetters(['defaultPlatform']),
	},
	data() {
		return {
			excludePlat: [+dataMap.PLATFORM_KS.value],
			delayDays: '',
			goodsDelayTimeOptList,
			platformId: '',
			delayOpenFlag: '',
			disabledDays: false,
			clashOpenFlag: '',
			clashRadio: 0,
			productAuditClaim: 0,
		};
	},
	mixins: [platformMixin],
	created() {
		this.platformId = +this.$route.query.platformId || +this.defaultPlatform;
		this.getProductPromotion();
		this.getProductDuplicate();
		this.getAuditConfigInfo();
	},
	methods: {
		async handleDelayDaysChange(val) {
			const { platformId } = this;
			await setProductPromotion({ platformId, is_open: this.delayOpenFlag, delay_days: val });
			this.$message.success('保存成功');
			this.getProductPromotion();
		},
		async toggleSwitch(val) {
			const { platformId } = this;
			this.delayOpenFlag = val;
			if (this.delayDays === '') {
				this.$message.warning('请先选择自动延长时间');
				this.delayOpenFlag = 0;
				return;
			}
			await setProductPromotion({ platformId, is_open: val, delay_days: this.delayDays });
			this.$message.success('保存成功');
			this.getProductPromotion();
		},
		async getProductPromotion() {
			const { platformId } = this;
			const data = await getProductPromotion({ platformId });
			if (!data) return;
			this.delayDays = +data.day;
			this.delayOpenFlag = +data.value;
		},
		handleClick(val) {
			this.platformId = val;
			this.getProductPromotion();
			this.getProductDuplicate();
			this.getAuditConfigInfo();
		},
		// 获取撞单规则
		async getProductDuplicate() {
			const { data, code } = await getProductConfig({ platformId: this.platformId });
			if (code === 0) {
				this.clashRadio = data.productDuplicateAlone;
				this.clashOpenFlag = data.productDuplicate;
			}
		},
		// 撞单规则
		async clashSwitch(val) {
			const { code } = await setProductDuplicate({ key: 'product_duplicate', value: val, platformId: this.platformId });
			if (code === 0) {
				this.$message.success(`${val ? '撞单总规则已开启' : '撞单总规则关闭'}`);
				this.clashOpenFlag = val;
				if (!val) {
					await setProductDuplicateAlone({
						key: 'product_duplicate_alone',
						value: 0,
						platformId: this.platformId,
					});
					this.clashRadio = 0;
				}
			}
		},

		// 获取商品审核设置
		async getAuditConfigInfo() {
			const { data, code } = await getAuditConfig({ platformId: this.platformId });
			if (code === 0) {
				this.productAuditClaim = data.productAuditClaim;
			}
		},
		// 商品审核设置
		async productAuditChange(val) {
			const { platformId } = this;
			const { code } = await setAuditConfig({ platformId, productAuditClaim: val });
			if (code === 0) {
				this.$message.success(`${val ? '审核自动认领已开启' : '审核自动认领关闭'}`);
				this.productAuditClaim = val;
			}
		},
		onRadio(val) {
			let textObj = {
				0: '可以审核所有商品',
				1: '不可以审核其他招商正在推广商品的店铺内所有商品',
			};
			this.$modal({
				content: `确认更换${textObj[val]}?`,
				size: 'small',
			}).then(async res => {
				if (res.key == 'confirm') {
					await setProductDuplicateAlone({
						key: 'product_duplicate_alone',
						value: val,
						platformId: this.platformId,
					});
					this.$message.success('操作成功！');
					this.clashRadio = val;
					res.done();
				} else {
					res.done();
				}
			});
		},
	},
};
</script>
<style lang="less" scoped>
.clash-icon {
	width: 15px;
	height: 15px;
}
</style>
